import { defineComponent as _defineComponent } from 'vue'
import { useGlobalBi } from '@/hooks/use-global-bi';
import { i18n } from '@/i18n';
import { useReturningUserStore } from '@/store/returning-user-module';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-base-utils';
import { SimpleCouponAwardCodeMap } from '@tencent/wphk-components-returning-user/types';
import { ScreenDialog } from '@tencent/wphk-ui';
import { computed, PropType, ref } from 'vue';
import { showReturnActExecDialog } from '../business/error-dialog';
import { useBiReport } from '../hooks/use-report';
import WxSubscribe from '@tencent/wphk-components-wx-subscribe/index.vue';
import { CHANLE_ID, SUBSCRIBE_CONFIG } from '@tencent/wphk-components-returning-user/config-subscribe';
import { initSubscribe, handleIsShowWxSubscribe, handleOnSuccess, handleOnFail } from '@tencent/wphk-components-wx-subscribe/business';


export default /*#__PURE__*/_defineComponent({
  __name: 'returning-act-dialog',
  props: {
  awardInfo: { type: Object as PropType<SimpleCouponAwardCodeMap>, required: true },
},
  emits: ['hideDialog'],
  setup(__props, { expose, emit }) {

const props = __props



const returningUserStore = useReturningUserStore();
const returningActDialog = ref<InstanceType<typeof ScreenDialog>>();
const { biExt } = useBiReport();
const { getBiExt } = useGlobalBi();
const dialogContent = computed(() => i18n('送你 merchantName 專屬優惠券', { merchantName: props.awardInfo?.coupon?.mrchName }));
/** 是否券包 */
const isCouponPkg = computed(() => props.awardInfo?.coupon?.isPkgCoupon);

/** 是否展示订阅开放标签 */
const isShowWxSubscribe = ref(false);
/** 订阅模板Id数组 */
const templateIds = SUBSCRIBE_CONFIG[0]?.templateId ? [SUBSCRIBE_CONFIG[0].templateId] : [];  // 订阅模板Id写在回流组件内

async function init() {
  // 初始化订阅
  initSubscribe(CHANLE_ID, SUBSCRIBE_CONFIG);
  isShowWxSubscribe.value = await handleIsShowWxSubscribe();
}
init();

/** 领取券 */
const getCoupon = async () => {
  showLoading();
  const [err] = await to(returningUserStore.execAct(props.awardInfo));
  hideLoading();
  if (err) {
    await showReturnActExecDialog(err as any);
  }
};
/** 展示弹窗 */
const showDialog = () => {
  (returningActDialog?.value as any)?.show();
};
/** 隐藏弹窗 */
const handleReceive = async () => {
  (returningActDialog?.value as any)?.hide();
  await getCoupon();
  handleCloseDialog();
};
// 通知外部关闭弹窗信息
const handleCloseDialog = () => {
  emit('hideDialog');
};

expose({
  showDialog,
});


/**
 * 订阅成功/订阅取消回调
 */
function onSuccess(res) {
  // 1、无论成功/取消，都要发起领券请求
  handleReceive();
  // 2、将订阅信息同步后台
  handleOnSuccess(res);
}

/**
 * 按钮操作失败回调(跟订阅成功/订阅失败没有关系)
 */
function onFail(res) {
  // 1、即使是操作失败，也要领券
  handleReceive();
  // 2、数据上报
  handleOnFail(res);
}


return { __sfc: true,props, emit, returningUserStore, returningActDialog, biExt, getBiExt, dialogContent, isCouponPkg, isShowWxSubscribe, templateIds, init, getCoupon, showDialog, handleReceive, handleCloseDialog, onSuccess, onFail, i18n, ScreenDialog, WxSubscribe }
}

})